import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ScreenSaverView from "../views/ScreenSaverView.vue";
import IFrameView from "../views/IFrameView.vue";

const routes = [
  {
    path: "/:lang(fr|de)?",
    children: [
      {
        path: "",
        name: "screensaver",
        component: ScreenSaverView,
      },
      {
        path: "home",
        name: "home",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "home"),
        }),
      },
      {
        path: "site",
        name: "site",
        component: IFrameView,
        props: (route) => ({ iframeUrl: route.query.url }),
      },
    ],
  },
];

const buttonsConfig = {
  fr: {
    home: [
      {
        text: "Ingénierie des sciences du vivant",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-d-ingenierie/sciences-du-vivant/formation-bachelor-ingenieure-en-sciences-du-vivant/",
          },
        },
      },
      {
        text: "Ingénierie des systèmes industriels",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-d-ingenierie/systemes-industriels/formation-bachelor-ingenieure-en-systemes-industriels/",
          },
        },
      },
      {
        text: "Énergie et techniques environnementales",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-d-ingenierie/energie-et-techniques-environnementales/formation-bachelor-d-ingenierie-en-energie-et-techniques-environnementales-200052",
          },
        },
      },
      {
        text: "Informatique et systèmes de communication",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-d-ingenierie/informatique-et-systemes-de-communication/bachelor-en-informatique-et-systemes-de-communication-201140",
          },
        },
      },
      {
        text: "La Haute École d'Ingénierie en vidéo",
        route: {
          name: "site",
          query: {
            url: "https://www.youtube.com/embed/km1_2AvURBw?rel=0&hl=fr",
          },
        },
      },
      {
        text: "La Haute École d'Ingénierie",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-d-ingenierie/",
          },
        },
      },
    ],
  },

  de: {
    home: [
      {
        text: " Life Sciences Engineering",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-ingenieurwissenschaften/life-sciences/bachelorstudium-in-life-sciences-engineering/",
          },
        },
      },
      {
        text: "Systems Engineering",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-ingenieurwissenschaften/systemtechnik/bachelorausbildung-in-systemtechnik/",
          },
        },
      },
      {
        text: "Energie und Umwelttechnik",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-ingenieurwissenschaften/energie-umwelttechnik/bachelorausbildung-in-energie-und-umwelttechnik-200052",
          },
        },
      },
      {
        text: "Informatik und Kommunikations-systeme",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-ingenieurwissenschaften/informatik-und-kommunikationssysteme/bachelorausbildung-in-informatik-und-kommunikationssysteme-201140",
          },
        },
      },
      {
        text: "Hochschule für Ingenieur-wissenschaften im Video",
        route: {
          name: "site",
          query: {
            url: "https://www.youtube.com/embed/km1_2AvURBw?rel=0&hl=de",
          },
        },
      },
      {
        text: "Hochschule für Ingenieur-wissenschaften",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-ingenieurwissenschaften/",
          },
        },
      },
    ],
  },
};

function getButtons(lang = "fr", section = "home") {
  return buttonsConfig[lang]?.[section] || buttonsConfig["fr"][section];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
